import React from "react";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";

function Icon({ id, open }: { id: number; open: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
}

export function AccordionCustomIcon({ accordionItems }: { accordionItems: any }) {
  const [open, setOpen] = React.useState(0);

  const handleOpen = (value: React.SetStateAction<number>) => setOpen(open === value ? 0 : value);

  return (
    <>
      {accordionItems.AccordionItems.map((item: any, index: number) => {
        return (
          <Accordion
            key={index}
            open={open === index + 1}
            icon={<Icon id={index + 1} open={open} />}
            placeholder=""
          >
            <AccordionHeader
              onClick={() => handleOpen(index + 1)}
              placeholder=""
              className="text-lg text-black"
            >
              {item.AccordionHeader}
            </AccordionHeader>
            <AccordionBody className="font-normal text-gray-600">
              {item.AccordionBody}
            </AccordionBody>
          </Accordion>
        );
      })}
    </>
  );
}
